import React,{Component} from 'react';
import {firestore} from '../../firebase/firebase.utils'
class Transaction extends Component {
	constructor(){
		super();
		this.state = {
			transactions: [],
		}
	}
  onOutgoing = () => {
	  const that = this;
	  let inc = []
    firestore.collection("transaction")
  .get()
  .then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        inc.push(doc.data())
      });
      that.setState({transactions:inc})
  })
  .catch(function(error) {
      console.log("Error getting documents: ", error);
  });
  }
  renderTableData() {
      return this.state.transactions.map((student, index) => {
         return (
            <tr className="stripe-dark" key={index}>
               <td className="pa3">{index}</td>
               <td className="pa3">{student.startid}</td>
               <td className="pa3">{student.transferid}</td>
               <td className="pa3">{student.points}</td>
               <td className="pa3">{student.comment}</td>
            </tr>
         )
      })
   }
   onShowt = () =>{
   	this.setState({rout:'show'}) 
        this.onOutgoing();
   	  }
   	  onHidet = () =>{
   	this.setState({rout:'hide'}) 
   	  }
	render(){
		if(this.state.rout==='show')
		{return(
			<div className="pa3 ba b--near-white bw2 bg-black o-60">
				<input
				onClick={this.onHidet}
                className="b ph3 pv2 pr4 input-reset ba b--white white bg-green grow pointer f6 dib"
                type="submit"
                value="Hide Transactions"
              />
				<div className="overflow-auto flex flex-column items-center pa3">
					<h1 className="near-white">All Transactions</h1>
				    <table classNameName="f6 w-100 mw8 center" cellspacing="0">
				      <thead>
				        <tr className="stripe-dark">
				          <th className="fw6 tl pa3 bg-white">ID</th>
				          <th className="fw6 tl pa3 bg-white">Sender ID</th>
				          <th className="fw6 tl pa3 bg-white">Reciever ID</th>
				          <th className="fw6 tl pa3 bg-white">Points</th>
				          <th className="fw6 tl pa3 bg-white">Comments</th>
				        </tr>
				      </thead>
				      <tbody className="lh-copy bg-near-white">
				      {this.renderTableData()}
				      </tbody>
				    </table>
				</div>
			</div>
			)
			}
			else{
				return<input
                onClick={this.onShowt}
                className="f3 link dim ph3 pv2 mb2 dib white bg-red"
                type="submit"
                value="Show Transactions"
              />
			}
		}
}

export default Transaction;